export const NUKE_LEGEND_ENTRIES = [
    {
        label: 'Solo Nuker',
        description: 'Requires less external support to obtain arts for nuking due to slots/passive',
    },
    {
        label: 'Player EXP',
        description: 'Has a Player EXP passive',
    },
    {
        label: 'High Self Buff',
        description: 'Provides a high amount of innate buffs to self',
    },
    {
        label: 'Self CRI',
        description: 'Provides CRI to self, disregarding reliance on allies/equips for CRI rate buffs',
    },
    {
        label: 'High RES Down',
        description: 'Inflicts a high amount of RES Down to enemy',
    },
    {
        label: 'High SCRI',
        description: 'Has >40% Super CRI rate on their nuke',
    },
    {
        label: 'Slot Mule',
        description: 'Exclusively used for their slots and passive to either clear waves or buff/debuff',
    },
    {
        label: 'High Accuracy',
        description: 'Has high Accuracy to nuke bosses, particularly useful against high evasion',
    },
    {
        label: 'Buff Passive',
        description: 'Provides buffs to the nuker via their passive',
    },
    {
        label: 'DEF Ignore',
        description: 'Provides DEF Ignore, useful for nuking bosses that negate CRI',
    },
    {
        label: 'Arts Passive',
        description: 'Provides teamwide Arts via their passive',
    },
    {
        label: 'HP Scaling',
        description: "Arts' DMG multiplier scales off their current HP",
    },
    {
        label: 'Jump Start',
        description: 'Obtains Arts every wave, allowing easy wave clear',
    },
    {
        label: 'One-Hit',
        description: 'Arts are able to skip boss thresholds when possible (usually on older bosses)',
    },
    {
        label: 'Arts Battery',
        description: 'Provides a burst of teamwide Arts upon usage of their own Arts',
    },
    {
        label: 'Time Stop',
        description: 'Prevent bosses from moving to enable nuker to skip I-Frames (usually on older bosses)',
    },
    {
        label: 'High DMG Up',
        description: 'Provides buffs to the nuker via their Arts',
    },
    {
        label: 'Reflect Nuker',
        description: 'Capable of using Reflect to nuke a boss (on older bosses with high DMG output)',
    },
];

const LEGEND_ALIASES = {
    'arts support': 'arts passive',
    'self buff': 'high self buff',
};

export function normalizeNukeLegendKey(label) {
    return String(label || '').trim().toLowerCase().replace(/\s+/g, ' ');
}

const legendByKey = NUKE_LEGEND_ENTRIES.reduce((map, entry) => {
    map[normalizeNukeLegendKey(entry.label)] = entry.description;
    return map;
}, {});

export function getNukeLegendDescription(label) {
    const normalized = normalizeNukeLegendKey(label);
    const alias = LEGEND_ALIASES[normalized];
    const lookupKey = alias ? normalizeNukeLegendKey(alias) : normalized;
    return legendByKey[lookupKey] || null;
}
